import { FilterIcon } from '@w/ui/components/icon'
import { Button } from '@w/ui/components/button'
import { Select, SelectTrigger, SelectValue, SelectPopup, SelectItem } from '@w/ui/components/select'
import { Popover, PopoverTrigger, PopoverPopup, PopoverClose } from '@w/ui/components/popover'
import { Menu, MenuTrigger, MenuPopup, MenuItem } from '@w/ui/components/menu'
import type { DatabaseProperty } from './database-properties'
import type { DatabaseFilter } from './database-sql'

export function DatabaseFilterControl({ properties, filter, onChange, open, onOpenChange }: {
  properties: readonly DatabaseProperty[]
  filter?: DatabaseFilter
  onChange: (filter?: DatabaseFilter) => void
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const choices = properties.filter(item => item.kind === 'select' || item.kind === 'multiSelect')
  const property = choices.find(item => item.name === filter?.column)
  const value = property?.options.find(option => option.id === filter?.optionId)
  return <Popover open={open} onOpenChange={onOpenChange}>
    <PopoverTrigger data-testid="database-filter" render={<Button size="sm" variant="text" aria-label="Filter" title={value ? `${property?.name}: ${value.label}` : 'Filter'} toggled={Boolean(value)} />}><FilterIcon /><span className="sr-only">{value ? `${property?.name}: ${value.label}` : 'Filter'}</span></PopoverTrigger>
    <PopoverPopup align="start" showArrow={false}>
      <div className="flex flex-wrap items-center gap-2">
        <Select value={property?.name ?? null} onValueChange={column => { if (column) onChange({ column }) }}>
          <SelectTrigger aria-label="Filter property" data-testid="database-filter-property"><SelectValue placeholder="Choose a property" /></SelectTrigger>
          <SelectPopup>{choices.map(item => <SelectItem key={item.name} value={item.name} data-testid={`database-filter-property-${item.name}`}>{item.name}</SelectItem>)}</SelectPopup>
        </Select>
        {property ? <>
          <span className="text-sm text-on-surface-secondary" data-testid="database-filter-operator">{property.kind === 'multiSelect' ? 'Contains' : 'Is'}</span>
          <Select value={value?.id ?? null} onValueChange={optionId => { if (optionId !== null) onChange({ column: property.name, optionId }) }}>
            <SelectTrigger aria-label="Filter value" data-testid="database-filter-value"><SelectValue placeholder="Choose an option" /></SelectTrigger>
            <SelectPopup>{property.options.map(option => <SelectItem key={option.id} value={option.id} data-testid={`database-filter-option-${option.label}`}>{option.label}</SelectItem>)}</SelectPopup>
          </Select>
        </> : null}
        {choices.length === 0 ? <p className="text-sm text-on-surface-secondary">Add a Select or Multi-select property to filter rows.</p> : null}
        {filter ? <Menu><MenuTrigger data-testid="database-filter-menu" render={<Button variant="text" aria-label="Filter actions" />}>⋯</MenuTrigger><MenuPopup><MenuItem data-testid="database-filter-delete" onClick={() => { onChange(); onOpenChange(false) }}>Delete filter</MenuItem></MenuPopup></Menu> : null}
        <PopoverClose data-testid="database-filter-done" render={<Button variant="text" />}>Done</PopoverClose>
      </div>
    </PopoverPopup>
  </Popover>
}
